import React from "react";
import colors from "../colors";
import { IconComponents } from "./used-icons";
import type { IconName, IconComponentProps } from "./generated-icons";

export interface IconProps {
  name: IconName;
  style?: object;
  size?: number;
  color?: string; // là path của colors trong styleguide hoặc hex color
  [key: string]: any;
}

export const Icons = ({
  name,
  size = 24,
  color = "currentColor",
  style,
  ...props
}: IconProps) => {
  // Get icon component from generated components
  const IconComponent = IconComponents[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  // Resolve color from styleguide or use direct color
  let resolvedColor = color;
  if (color && color.includes(".") && colors) {
    // Handle nested color paths like "primary.main"
    const colorPath = color.split(".");
    let colorValue: any = colors;
    for (const path of colorPath) {
      if (typeof colorValue === "object" && colorValue !== null) {
        colorValue = colorValue[path];
      } else {
        colorValue = undefined;
        break;
      }
    }
    resolvedColor = typeof colorValue === "string" ? colorValue : color;
  }

  return (
    <IconComponent size={size} color={resolvedColor} style={style} {...props} />
  );
};

export default Icons;

// Export types for external use
export type { IconName, IconComponentProps };

// Export individual icon components for direct usage (tree-shaking friendly)
export { IconComponents } from "./generated-icons";
